import React from "react";
import PropTypes from "prop-types";
import {Picture, Source, Img} from '@xo-union/tk-component-picture';
import Spinner from '@xo-union/tk-component-spinner';
import styles from './lazyload-image.css';

class LazyloadImage extends React.Component {
  constructor(props) {
    super(props)
    this.imgContainer = React.createRef()
    this.state = {
      show_spinner: props.show_spinner
    }
  }

  static defaultProps = {
    lazy: true,
    show_spinner: true
  };

  componentDidMount() {
    let img = this.imgContainer.current.querySelector('img')
    let _this = this
    img.addEventListener('load', function() {
      if (img.complete) {
        _this.setState({
          show_spinner: false
        })
      }
    })
  }

  render() {
    let containerClassName = this.props.containerClassName || '';
    let imageClassName = this.props.imageClassName || '';
    let image = this.props.image || '';
    let img_ratio = this.props.img_ratio;
    let imageId = image.split('/').pop().split('~').shift();
    let altText = this.props.alt;
    let elementPros = {};
    let { ariaHidden, desktopWidth, desktopHeight, mobileWidth, mobileHeight, smartCrop, lazy } = this.props;
    let { show_spinner } = this.state;

    return (<div className={`${styles['lazyload-image-container']} ${styles[containerClassName]}`}
                 aria-hidden={ariaHidden}
                 ref={this.imgContainer}
                 style={img_ratio && parseInt(img_ratio) ? {paddingBottom: img_ratio, height: 0} : {}}>
      <Spinner className={styles['spinner-container']} style={ {display: show_spinner ? 'block' : 'none'} }/>
      <Picture id={imageId} pixelDensities={[1,2]} lazy={lazy} elementProps={{className: styles['picture-container']}}>
        <Source viewport="md" width={desktopWidth} height={desktopHeight} smartCrop={smartCrop}/>
        <Source viewport="xs" width={mobileWidth} height={mobileHeight} smartCrop={smartCrop}/>

        <Img pixelDensity={1} className={imageClassName} elementProps={elementPros} width={desktopWidth} height={desktopHeight} alt={altText} smartCrop={smartCrop} lazy={lazy}/>
      </Picture>
    </div>);
  }
};

LazyloadImage.propTypes = {
  containerClassName: PropTypes.string,
  imageClassName: PropTypes.string,
  image: PropTypes.string,
  alt: PropTypes.string
};

export default LazyloadImage;
